export const taxes = {

		tax_20: 1.2,
		'tax_5.5': 0.55,
	};
